import React from 'react';
import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl';
import PropTypes from 'prop-types';

import { intlForProgram } from '../intl/intlSelectors';
import { getActiveProgramCode } from './programSelectors';


const PureProgramIntlProvider = ({ children, programCode, getProgramIntl }) => {
    
    
    const programIntl = getProgramIntl(programCode);
    return (
        <IntlProvider {...programIntl}>
            { children }
        </IntlProvider>
    );
};

PureProgramIntlProvider.defaultProps = {
    programCode: null
};

PureProgramIntlProvider.propTypes = {
    getProgramIntl: PropTypes.func.isRequired,
    programCode: PropTypes.string,
    children: PropTypes.node.isRequired
};

const mapStateToProps = state => ({
    programCode: getActiveProgramCode(state),
    getProgramIntl: intlForProgram(state)
});

export default connect(mapStateToProps)(PureProgramIntlProvider);
